var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['balance-amount', {'muted': _vm.mutedText, 'negative': _vm.isNegativeAmount }]},[_vm._v("\n  "+_vm._s(_vm.formatCurrency(_vm.amount))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }